var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarma35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 508.027 508.027",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "seg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.3165,
    height: 25,
    className: "fill",
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.513 138.813-41.4-22.6c-6.8-3.7-15.4-1.2-19.1 5.6-3.7 6.8-1.2 15.4 5.7 19.1l41.3 22.6c6.8 3.7 15.4 1.2 19.1-5.6 3.7-6.8 1.2-15.4-5.6-19.1zM161.613 73.513l-23.2-38.2c-4-6.7-12.7-8.8-19.4-4.7-6.7 4-8.8 12.7-4.7 19.4l23.2 38.2c4 6.7 12.7 8.8 19.4 4.7 6.7-4.1 8.8-12.7 4.7-19.4zM254.013.013c-7.8 0-14.1 6.3-14.1 14.1v43.4c0 7.8 6.3 14.1 14.1 14.1s14.1-6.3 14.1-14.1v-43.4c0-7.8-6.3-14.1-14.1-14.1zM389.013 30.613c-6.7-4-15.3-1.9-19.4 4.7l-23.2 38.2c-4 6.7-1.9 15.4 4.7 19.4 6.7 4.1 15.3 1.9 19.4-4.7l23.2-38.2c4-6.7 1.9-15.3-4.7-19.4zM493.913 121.813c-3.7-6.8-12.3-9.4-19.1-5.6l-41.4 22.6c-6.8 3.7-9.3 12.2-5.6 19.1 3.7 6.8 12.3 9.4 19.1 5.6l41.4-22.6c6.8-3.7 9.4-12.3 5.6-19.1zM507.013 488.713l-25.1-63.4c-2.1-5.4-7.3-8.9-13.1-8.9h-29.4l-30.2-220.5c-5.2-40-39.4-70.1-79.8-70.1h-150.9c-40.3 0-74.6 30.1-79.7 70l-30.2 220.5h-29.4c-5.8 0-11 3.5-13.1 8.9l-25.1 63.5c-3.7 9.3 3.2 19.3 13.1 19.3h479.8c9.9 0 16.8-10 13.1-19.3zm-380.2-289.2c3.3-26 25.6-45.5 51.8-45.5h150.9c26.2 0 48.4 19.6 51.8 45.6l29.7 216.7h-313.9l29.7-216.8zm-91.9 280.3 13.9-35.2h410.4l13.9 35.2h-438.2z",
    fill: "#4f4f4f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.913 205.313v29.6l6.9 86h28.2l7.1-86v-29.6z",
    fill: "#4f4f4f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.013,
    cy: 358.013,
    r: 21,
    fill: "#4f4f4f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarma35);
export default __webpack_public_path__ + "static/media/Alarma35.4d8bd6bf.svg";
export { ForwardRef as ReactComponent };